import {
  Typography,
  Button,
  IconButton,
  Box,
  Menu,
  Stack,
  alpha,
  MenuItem,
  MenuList,
  ListItemIcon,
  CircularProgress,
  Tooltip
} from '@mui/material';
import { red } from '@mui/material/colors';
import { useTheme } from '@mui/material/styles';
import {
  PictureAsPdf,
  Menu as MenuIcon,
  AccessTime,
  South,
  CloudDownload,
  Visibility,
  Send
} from '@mui/icons-material';
import { makeStyles, withStyles } from '@mui/styles';
import { useState } from 'react';
import PreviewAndComplete from '../Questionnaire/QuestionnaireDetail/PreviewAndComplete';
import { URLS } from '../../apis/urls';
import { quotationSendEmail } from '../../apis/buyersGuideApis';
import { useTranslation } from 'react-i18next';

const StyledMenuItem = withStyles((theme) => ({
  root: {
    whiteSpace: "pre-wrap",
    padding: theme.spacing(1, 0),
    "& div": {
      minWidth: 40,
      color: theme.palette.grey[700],
    },
    "& span": {
      color: theme.palette.grey[700],
      fontSize: 12,
    },
  },
}))(MenuItem);

const RenterInformationTitle = ({
  openAction,
  menuAnchorEl,
  handleMenuClick,
  handleMenuClose,
  handleMenuSelect,
  isClosed,
  hasDocument,
  file,
  canProlong,
  canWithdraw,
  quoteId
}) => {

  const theme = useTheme();
  const { t } = useTranslation();
  const isMenuOpen = Boolean(menuAnchorEl);
  const classes = useStyles();
  const [reportPopOverEl, setReportPopOverEl] = useState(null);
  const [pdfMenuLoading, setPdfMenuLoading] = useState(false);
  const [openCompleteDialog, setOpenCompleteDialog] = useState(false)

  const handlePdfMenuOpen = (e) => {
    setReportPopOverEl(e.currentTarget);
  };

  const handlePdfMenuClose = () => {
    setReportPopOverEl(null);
  };

  const handleQuotationSendEmail = async (payload) => {
    await quotationSendEmail(quoteId, payload);
  };

  return (
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="h6">{t('buyersGuide.options.generate.buyerRenterInformation')}</Typography>
      <Box display={{ xs: 'block', sm: 'none' }}>
        {isClosed &&
          <IconButton
            aria-label="PDF"
            size="small"
            onClick={handlePdfMenuOpen}
          >
            <PictureAsPdf style={{ fill: red[800] }} />
          </IconButton>
        }
        {!isClosed && (
          <IconButton
            aria-label="menu"
            size="small"
            onClick={handleMenuClick}
          >
            <MenuIcon />
          </IconButton>
        )}


        <Menu
          anchorEl={menuAnchorEl}
          open={isMenuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              p: 2,
              borderRadius: 2,
              boxShadow: 3,
              width: 220
            }
          }}
        >
          {!isClosed && (
            <Button
              variant="text"
              size="small"
              fullWidth
              startIcon={<PictureAsPdf style={{ fill: red[800] }} />}
              onClick={() => handleMenuSelect('quotation')}
            >
              {t('general.pdf')}
            </Button>
          )}
          <Stack spacing={1}>

            {hasDocument && !isClosed && (
              <>
                {
                  canProlong && (
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      startIcon={<AccessTime />}
                      sx={{
                        bgcolor: theme.palette.warning.main,
                        '&:hover': {
                          bgcolor: theme.palette.warning.dark
                        }
                      }}
                      onClick={(e) => openAction(e, 'prolong')}
                    >
                      {t('general.prolong')}
                    </Button>)
                }
                {
                  canWithdraw && (
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      startIcon={<South />}
                      sx={{
                        bgcolor: theme.palette.error.main,
                        '&:hover': {
                          bgcolor: theme.palette.error.dark
                        }
                      }}
                      onClick={(e) => openAction(e, 'withdraw')}
                    >
                      {t('general.withdraw')}
                    </Button>
                  )
                }

              </>)}
          </Stack>
        </Menu>
      </Box>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ display: { xs: 'none', sm: 'flex' } }}
      >
        {!isClosed && (
          <Tooltip title={t('buyersGuide.quotation.quotationTooltip')}>
            <IconButton
              aria-label="PDF"
              size="small"
              onClick={() => handleMenuSelect('quotation')}
            >
              <PictureAsPdf color="error" />
            </IconButton>
          </Tooltip>
        )}
        {isClosed &&
          <IconButton
            aria-label="PDF"
            size="small"
            onClick={handlePdfMenuOpen}
          >
            <PictureAsPdf style={{ fill: red[800] }} />
          </IconButton>
        }

        {hasDocument && !isClosed && (
          <>
            {
              canProlong && (
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    bgcolor: theme.palette.warning.main,
                    '&:hover': { bgcolor: theme.palette.warning.dark }
                  }}
                  onClick={(e) => openAction(e, 'prolong')}
                >
                  {t('general.prolong')}
                </Button>
              )}
            {canWithdraw && (
              <Button
                variant="contained"
                size="small"
                sx={{
                  bgcolor: theme.palette.error.main,
                  '&:hover': { bgcolor: theme.palette.error.dark }
                }}
                onClick={(e) => openAction(e, 'withdraw')}
              >
                {t('general.withdraw')}
              </Button>
            )}
          </>)}
      </Stack>
      <Menu
        className={classes.menuContent}
        anchorEl={reportPopOverEl}
        open={Boolean(reportPopOverEl)}
        onClose={handlePdfMenuClose}
        keepMounted
        elevation={1}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuList className={classes.menuListStyle}>
          <StyledMenuItem disabled={pdfMenuLoading === "download"}
            onClick={() => {
              setPdfMenuLoading("download");
              setTimeout(() => {
                setPdfMenuLoading(null);
                handlePdfMenuClose();
              }, 800);
            }}
            component={"a"} href={URLS.GET_ATTACHMENT + file?.id} download>
            <ListItemIcon>{pdfMenuLoading === "download" ? <CircularProgress size={18} style={{ minWidth: 0 }} color="primary" /> : <CloudDownload className={classes.menuIcon} color={"primary"} />}</ListItemIcon>
            <Typography variant="inherit">{t("general.download")}</Typography>
          </StyledMenuItem>
          <StyledMenuItem
            disabled={pdfMenuLoading === "view"}
            onClick={() => {
              setPdfMenuLoading("view");
              handleMenuSelect("quotation");

              setTimeout(() => {
                setPdfMenuLoading(null);
                handlePdfMenuClose();
              }, 300);
            }}    >
            <ListItemIcon>{pdfMenuLoading === "view" ? <CircularProgress size={18} style={{ minWidth: 0 }} color="primary" /> : <Visibility className={classes.menuIcon} color={"primary"} />}</ListItemIcon>
            <Typography variant="inherit">{t("general.show")}</Typography>
          </StyledMenuItem>
          <StyledMenuItem onClick={() => { setOpenCompleteDialog(true) }} >
            <ListItemIcon>
              <Send className={classes.menuIcon} color={"primary"} />
            </ListItemIcon>
            <Typography variant="inherit">{t("general.send")}</Typography>
          </StyledMenuItem>


        </MenuList>
      </Menu>

      <PreviewAndComplete
        open={openCompleteDialog}
        closeModalHandler={() => setOpenCompleteDialog(false)}
        onSend={handleQuotationSendEmail}

      />
    </Box>
  );
};

export default RenterInformationTitle;
const useStyles = makeStyles((theme) => ({
  "@global": {
    ".MuiButtonBase-root:focus": {
      outline: 0,
    },
  },
  menuListStyle: {
    padding: theme.spacing(1.875, 1.25),
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
    borderRadius: 10,
    width: 167,
  },
  menuIcon: {
    marginRight: 10,
  },
  menuContent: {
    "& .MuiPopover-paper": {
      borderRadius: 10,
      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px !important",
    },
    "& ul": {
      padding: theme.spacing(0),
    },
    "& ul > ul": {
      padding: theme.spacing(0.5, 2),
    },
  },
  detailSubItem: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "-webkitLineClamp": 1,
    "-webkitBoxOrient": "vertical",
  },
  detailsContain: {
    flexGrow: 1,
  },
  signButton: {
    fontSize: 12,
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
      padding: theme.spacing(0.2, 1.9),
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: 16,
      padding: theme.spacing(0.2, 1.9),
    },
    fontWeight: "normal",
    marginLeft: 8,
    whiteSpace: "nowrap",
  },
  detailSubContainer: {
    [theme.breakpoints.down("sm")]: {
      padding: `5px !important`,
    },
  },
  detailChip: {
    height: 25,
    fontSize: 12,
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(1.2, 1),
      fontSize: 14,
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: 16,
    },
    padding: theme.spacing(0),
  },
  detailMainHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",


    minHeight: 57,
  },
  detailText: {
    fontSize: 12,
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: 16,
    },
    color: theme.palette.common.black,
    fontWeight: "bold",
    whiteSpace: "nowrap",
    paddingRight: theme.spacing(2),
  },
  detailSubText: {
    fontSize: 12,
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: 16,
    },
    color: theme.palette.grey[600],
    wordBreak: "break-all",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkitLineClamp": 1,
    "-webkitBoxOrient": "vertical",
  },
  detailPaper: {
    height: 70,
    [theme.breakpoints.down("sm")]: {
      height: 110,
    },
    borderLeft: `2px solid ${theme.palette.primary.main}`,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    background: alpha(theme.palette.primary.main, 0.05),
    boxShadow: "none",
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
  },
  detailInnerPapper: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    flexGrow: 1,
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      height: "100%",
    },
  },
  detailContainer: {
    paddingBottom: theme.spacing(1.5),
  },
  detailHeader: {
    fontSize: 16,
    color: theme.palette.grey[800],
    fontWeight: "bold",
  },
  dottedBottomBorder: {
    borderBottom: `1px dotted ${theme.palette.grey[600]}`,
    cursor: "default",
  },
}));